import { render } from "./BillView.vue?vue&type=template&id=23b37a56&scoped=true"
import script from "./BillView.vue?vue&type=script&lang=js"
export * from "./BillView.vue?vue&type=script&lang=js"

import "./BillView.vue?vue&type=style&index=0&id=23b37a56&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23b37a56"]])

export default __exports__